module.exports = __webpack_public_path__ + "img/Products.288fedab.svg";